module.exports = __webpack_public_path__ + "static/home-bg-fbe3060e3fa73d2e668651d7556968bf.jpg";